import PropTypes from 'prop-types';
import React from 'react';

import {LOAD_BAR} from '../../../constants/loadBar';
import {RECAPTCHA_ACTIONS} from '../../../constants/recaptcha';
import {PSR_TYPES} from '../../../constants/typesMessages';
import {useGetConditions} from '../../../hooks/useGetConditions';
import {useGetProductsCnae} from '../../../hooks/useGetProductsCnae';
import {useRecaptchaProtection} from '../../../hooks/useRecaptchaProtection';
import {sendAddresses} from '../../../services/Api';
import {showErrors} from '../../../services/errorsMessages';
import {
  checkPropertiesAddressFromAPI,
  updateComplementOfAddress
} from '../../../services/flowAddress';
import {HideButtonWhenLogout} from '../../../shared/components/HideButtonWhenLogout';
import {useChatStore} from '../../../store/slices/chatStore';
import {useEcStore} from '../../../store/slices/ecStore';
import {useInteractionStore} from '../../../store/slices/interactionStore';

const MessageAddressFromBureauComplementConfirm = (props) => {
  const ecState = useEcStore((state) => state.ec);
  const ecStateId = useEcStore((state) => state.ec.id);
  const updateAddress = useEcStore((state) => state.updateAddress);
  const sendMessage = useChatStore((state) => state.sendMessage);
  const responseTypeChange = useChatStore((state) => state.responseTypeChange);
  const setMessages = useChatStore((state) => state.setMessages);
  const setChatStageFlow = useChatStore((state) => state.setChatStageFlow);
  const disabledButtonSendMessage = useInteractionStore(
    (state) => state.disabledButtonSendMessage
  );
  const setDotTyping = useInteractionStore((state) => state.setDotTyping);
  const {executeWithProtection} = useRecaptchaProtection();
  const index = props.content.index;
  useGetProductsCnae();
  useGetConditions();

  const complementYes = () => {
    document.getElementById(
      `button-option-address-complement-confirme_${index}`
    ).classList = 'hidden';
    let message = {
      text: 'Sim',
      type: 'response-sent'
    };
    sendMessage(message);

    message = {
      text: `Por favor, digite o complemento.`,
      type: 'message-receive',
      responseType: 'address-complement-from-api-input',
      index: index,
      step: 'address'
    };

    sendMessage(message);
    responseTypeChange(message.responseType);
    disabledButtonSendMessage('');
  };

  const complementNo = () => {
    document.getElementById(
      `button-option-address-complement-confirme_${index}`
    ).classList = 'hidden';
    let message = {
      text: 'Não',
      type: 'response-sent',
      step: 'address',
      index: index
    };
    sendMessage(message);
    const addresses = updateComplementOfAddress(
      index,
      'Endereço não possui complemento',
      ecState.addresses
    );
    updateAddress(addresses);
    const updatedEcState = {...ecState, addresses};
    message = checkPropertiesAddressFromAPI(updatedEcState, index);
    addressDispatchHandler(message);
  };

  const addressDispatchHandler = (message) => {
    setDotTyping(true);
    if (message.type === 'message-receive-address-type') {
      let showAddressBeforeType = {
        type: 'start-addresses-flow',
        index: message.index,
        step: 'address'
      };
      sendMessage(showAddressBeforeType);
    } else if (message.send) {
      executeWithProtection(
        (payload, token) => sendAddresses(ecStateId, payload, token),
        RECAPTCHA_ACTIONS.DATA_UPDATE,
        ecState.addresses
      )
        .then(function () {
          message = {
            type: PSR_TYPES.PSR_PAYMENT
          };
          sendMessage(message);
          setChatStageFlow(LOAD_BAR.ADDRESS);
        })
        .catch(function (error) {
          const showResponse = showErrors(error, 'endereços');
          setMessages(showResponse.messages);
        });
    } else {
      sendMessage(message);
      if (message.responseType) {
        responseTypeChange(message.responseType);
      }
    }
    setDotTyping(false);
  };

  return (
    <div>
      <div className="message-line">
        <div
          className="message-receive"
          id={`msg-${props.content.id}`}
          data-aut-test="message-receive-text"
        >
          <div className="message-div">{props.content.text}</div>
        </div>
      </div>
      <HideButtonWhenLogout>
        <div
          className="message-line"
          id={`button-option-address-complement-confirme_${index}`}
          data-aut-test="button-option-address-complement-confirme"
        >
          <div className="div-button">
            <button
              data-aut-test="complement-confirm-no"
              data-testid="complement-confirm-no"
              id={`complement-confirm-nao_${index}`}
              type="button"
              onClick={() => complementNo()}
            >
              NÃO
            </button>
            <button
              id={`complement-confirm-sim_${index}`}
              data-aut-test="complement-confirm-yes"
              data-testid="complement-confirm-yes"
              type="button"
              onClick={() => complementYes()}
            >
              SIM
            </button>
          </div>
        </div>
      </HideButtonWhenLogout>
    </div>
  );
};

MessageAddressFromBureauComplementConfirm.propTypes = {
  content: PropTypes.object
};

export default MessageAddressFromBureauComplementConfirm;
